/**
 * A modal that displayes the campaign terms and conditions
 * @param $scope
 * @param $uibModalInstance
 * @constructor
 */
function TermsAndConditionsModalController($scope, $uibModalInstance) {

    var self = this;

    /**
     * Initialises the component
     */
    self.initialise = function() {

    };

    /**
     * Closes the modal
     */
    $scope.closeModal = function () {
        $uibModalInstance.close();
    };

    self.initialise();
}

angular
    .module('dashboard')
    .controller('TermsAndConditionsModalController', ['$scope', '$uibModalInstance', TermsAndConditionsModalController]);